// src/components/home/NewArrivals/NewArrivals.jsx
import React, { useEffect, useRef, useState, useContext } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FaStar } from "react-icons/fa";
import { ProductsSkeleton } from "../../../../components/general/skeleton/SkeletonBlock";
import ProductCard from "../../../../components/customer/cards/productCard/ProductCard";
import "../../../../assets/css/customer/home/newArrivals/NewArrivals.css";
import Swal from "sweetalert2";
import axios from "axios";
// ✅ LOCAL IMAGES ONLY
import wheat from "../../../../assets/images/products/wheat.webp";
import cottonseeds from "../../../../assets/images/products/cottonseeds.jpg";
import blueberries from "../../../../assets/images/products/Blueberries.jpeg";
import millet from "../../../../assets/images/products/millet.jpeg";
import MyContext from "../../../../context/MyContext";

const NewArrivals = () => {
  const { baseUrl, baseUrlForFiles } = useContext(MyContext);
  const [products, setProducts] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(true);
  const [newArrivals, setNewArrivals] = useState([]);
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  const viewAllProducts = () => {
    axios
      .get(`${baseUrl}/customer/product/viewAllProducts`)
      .then((response) => {
        console.log(response.data);
        if (response.data.hasOwnProperty("error")) {
          setErrorMessage(response.data.error);
          Swal.fire({
            icon: "error",
            title: "Error",
            text: response.data.error,
          });
        } else {
          setProducts(response.data.product);
        }
      });
  };
  //  useEffect(() => {
  //   viewAllProducts();
  // }, []);
  useEffect(() => {
    viewAllProducts();
    setLoading(false);
  }, []);
  // ✅ ASYNC DATA FETCH — 300ms skeleton
  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       // TODO: Replace with real API → await fetch('/api/new-arrivals')
  //       await new Promise((resolve) => setTimeout(resolve, 300));

  //       setNewArrivals([
  //         {
  //           id: 1,
  //           name: "Fresh Tomatoes",
  //           category: "Crops",
  //           subcategory: "Vegetables",
  //           price: 90,
  //           oldPrice: 120,
  //           rating: 4,
  //           reviews: 38,
  //           unit: "kg",
  //           image:
  //             "https://images.unsplash.com/photo-1592924357228-91a4daadcfea?w=400&h=400&fit=crop",
  //           badge: { text: "Sale", type: "sale" },
  //           shopName: "Chaudhry Agri Store — Lahore",
  //           shopId: 1,
  //         },

  //         {
  //           id: 22,
  //           name: "BT Cotton Seeds",
  //           category: "Store Products",
  //           subcategory: "Seeds",
  //           price: 1800,
  //           oldPrice: null,
  //           unit: "5kg bag",
  //           image: cottonseeds,
  //           rating: 4,
  //           reviews: 44,
  //           badge: { type: "organic", text: "Organic" },
  //           shopName: "Green Valley Seeds Store",
  //           shopId: 2,
  //         },
  //         {
  //           id: 23,
  //           name: "Fresh Blueberries",
  //           category: "Crops",
  //           subcategory: "Fruits",
  //           price: 650,
  //           oldPrice: 800,
  //           unit: "per kg",
  //           image: blueberries,
  //           rating: 5,
  //           reviews: 67,
  //           badge: { type: "new", text: "New" },
  //           shopName: "Green Valley Organic Farm",
  //           shopId: 3,
  //         },
  //         {
  //           id: 24,
  //           name: "Premium Millet Seeds",
  //           category: "Crops",
  //           subcategory: "Wheat & Grains",
  //           price: 900,
  //           oldPrice: 1200,
  //           unit: "10kg bag",
  //           image: millet,
  //           rating: 5,
  //           reviews: 45,
  //           badge: { type: "hot", text: "Hot" },
  //           shopName: "Punjab Grain Market — Lahore",
  //           shopId: 4,
  //         },
  //       ]);
  //     } catch (error) {
  //       console.error("Failed to load new arrivals:", error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  //   fetchData();
  // }, []);

  // ✅ FIX: Observer attaches AFTER loading=false so sectionRef is mounted
  useEffect(() => {
    if (loading) return;

    // Immediately visible if already in viewport
    if (sectionRef.current) {
      const rect = sectionRef.current.getBoundingClientRect();
      if (rect.top < window.innerHeight) {
        setIsVisible(true);
        return;
      }
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.05, rootMargin: "0px 0px -40px 0px" },
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => {
      if (sectionRef.current) observer.unobserve(sectionRef.current);
    };
  }, [loading]); // ← key fix: runs when loading becomes false

  // ✅ LOADING STATE
  if (loading) {
    return (
      <section className="na-arrivals-section">
        <Container>
          <ProductsSkeleton count={4} />
        </Container>
      </section>
    );
  }

  return (
    <section
      className={`na-arrivals-section ${isVisible ? "na-is-visible" : ""}`}
      ref={sectionRef}
    >
      <Container>
        {/* ✅ Section Header — always rendered, animation class added on visible */}
        <div className="na-section-header">
          <span className="na-section-subtitle">
            <FaStar className="na-star-icon" /> Just Arrived
          </span>
          <h2 className="na-section-title">New Arrivals</h2>
          <p className="na-section-description">
            Check out our latest additions of products
          </p>
        </div>

        {/* Products Grid */}
        <Row className="g-4">
          {products.map((product, index) => (
            <Col key={product.id} xs={12} sm={6} md={4} lg={3}>
              <ProductCard
                product={product}
                index={index}
                baseUrlForFiles={baseUrlForFiles}
              />
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default NewArrivals;
